export default __webpack_public_path__ + "static/media/hall_of_fame_two.440f0e5b.png";